import { useReport } from './hooks/useReport';
import ReportForm from './components/ReportForm';
import './reportModal.scss';

const ReportModal = ({ isOpen, onClose, targetId, targetType }) => {
    const {
        reason, setReason,
        description, setDescription,
        errorMessage,
        handleSubmit, handleClose,
        isPending, isSuccess
    } = useReport(targetId, targetType, onClose);

    if (!isOpen) return null;

    const modalTitle = targetType === 'POST' ? 'Report article' : 'Commentary report';

    return (
        <div className="report-modal-overlay" onClick={handleClose}>
            <div className="report-modal-container" onClick={(e) => e.stopPropagation()}>
                
                <div className="report-modal-header">
                    <h2>{modalTitle}</h2>
                    <span className="close-btn" onClick={handleClose}>&times;</span>
                </div>

                {isSuccess ? (
                    <div className="report-success">
                        Thank you! The report has been successfully submitted.
                    </div>
                ) : (
                    <ReportForm
                        reason={reason}
                        setReason={setReason}
                        description={description}
                        setDescription={setDescription}
                        errorMessage={errorMessage}
                        isPending={isPending}
                        onSubmit={handleSubmit}
                        onCancel={handleClose}
                    />
                )}
                
            </div>
        </div>
    );
};

export default ReportModal;